/*!
 * dasoertliche-javascript-library-7.26
 * 
 * Copyright (C) 2008-2025 TENSQUARE GmbH. All rights reserved.
 * https://www.tensquare.de
 * Die Inhalte dieser Datei sind urheberrechtlich geschützt. Sie dürfen
 * weder ganz noch in Teilen vervielfältigt, verbreitet oder öffentlich
 * zugänglich gemacht werden. Jegliche Nutzung, sowohl zu privaten als
 * auch zu kommerziellen Zwecken, bedarf der schriftlichen Genehmigung
 * der TENSQUARE GmbH.
 */
(function(window) {
    function WebStorageHandler() {
        var OE_ITEM_NAME = "oeProperties", DEFAULT_OE_PROPERTIES = {
            consent: {
                wa: false
            }
        }, ls = window.localStorage;
        function b64EncodeUnicode(str) {
            return btoa(encodeURIComponent(str));
        }
        function unicodeDecodeB64(str) {
            return decodeURIComponent(atob(str));
        }
        function isJson(value) {
            value = typeof value !== "string" ? JSON.stringify(value) : value;
            try {
                value = JSON.parse(value);
            } catch (e) {
                return false;
            }
            return value !== null && typeof value === "object";
        }
        function getItem(itemName) {
            var item;
            item = ls.getItem(itemName);
            if (typeof item === "string") {
                item = unicodeDecodeB64(item);
            }
            if (isJson(item)) {
                item = JSON.parse(item);
            }
            return item;
        }
        function setItem(itemName, itemValue) {
            try {
                if (isJson(itemValue)) {
                    itemValue = JSON.stringify(itemValue);
                }
            } catch (e) {}
            if (typeof itemValue === "string") {
                itemValue = b64EncodeUnicode(itemValue);
            }
            ls.setItem(itemName, itemValue);
        }
        function getOeProperties() {
            return getItem(OE_ITEM_NAME);
        }
        function setOeProperties(value) {
            if (value !== Object(value)) {
                return false;
            }
            setItem(OE_ITEM_NAME, value);
            return true;
        }
        function addOeProperty(name, value) {
            var oeProperties = getOeProperties() || getDefaultOeProperties();
            oeProperties[name] = value;
            setOeProperties(oeProperties);
        }
        function addOeProperties(obj) {
            if (!isJson(obj) || !isObject(obj) || obj.constructor === Array) {
                throw new Error("Failed to add: " + obj);
            }
            setOeProperties(deepMerge(getOeProperties() || getDefaultOeProperties(), obj || {}));
        }
        function setWaConsent(consent) {
            var oeProps;
            oeProps = getItem(OE_ITEM_NAME);
            if (oeProps !== Object(oeProps)) {
                oeProps = getDefaultOeProperties();
            }
            if (!oeProps.consent) {
                oeProps.consent = {};
            }
            oeProps.consent.wa = consent;
            setItem(OE_ITEM_NAME, oeProps);
        }
        function getWaConsent() {
            var oeProps = getItem(OE_ITEM_NAME);
            if (oeProps === Object(oeProps) && oeProps.consent && typeof oeProps.consent.wa === "boolean") {
                return oeProps.consent.wa;
            }
            return false;
        }
        function getDefaultOeProperties() {
            return DEFAULT_OE_PROPERTIES;
        }
        function getOePropertiesName() {
            return OE_ITEM_NAME;
        }
        function removeItem(itemName) {
            ls.removeItem(itemName);
        }
        function deepMerge(objs) {
            var result = {}, args = arguments, source, sourceProp, destProp;
            for (var i = 0, len = args.length; i < len; i++) {
                source = args[i];
                for (var member in source) {
                    if (!source.hasOwnProperty(member)) {
                        continue;
                    }
                    sourceProp = source[member];
                    destProp = result[member];
                    if (isObject(sourceProp)) {
                        if (isObject(destProp)) {
                            result[member] = deepMerge(destProp, sourceProp);
                            continue;
                        }
                    }
                    result[member] = sourceProp;
                }
            }
            return result;
        }
        function isObject(x) {
            return x === Object(x);
        }
        this.getDefaultOeProperties = getDefaultOeProperties;
        this.removeItem = removeItem;
        this.getOePropertiesName = getOePropertiesName;
        this.getItem = getItem;
        this.setItem = setItem;
        this.getOeProperties = getOeProperties;
        this.setOeProperties = setOeProperties;
        this.addOeProperty = addOeProperty;
        this.addOeProperties = addOeProperties;
        this.getWaConsent = getWaConsent;
        this.setWaConsent = setWaConsent;
        this.isJson = isJson;
        this.deepMerge = deepMerge;
    }
    window.WebStorageHandler = WebStorageHandler;
})(this);